import React, { useCallback } from "react";
import DatePicker from "@ls/react-date-picker";
import {
  selectSymbolicDate,
  selectAsOfDateValue,
} from "state/selections/selector";
import { useDispatch, useSelector } from "react-redux";
import { setAsOfDate, setSymbolicDate } from "state/selections/actions";
import SelectionState from "state/selections/SelectionState";

const quickSelectButtons = ["PYE", "PQE", "PME", "PBD", "CBD"];
const AsOfDatePicker = () => {
  const dispatch = useDispatch();
  const asOfDate = useSelector(selectAsOfDateValue(SelectionState.UNCOMMITTED));
  const symbolicDate = useSelector(
    selectSymbolicDate(SelectionState.UNCOMMITTED)
  );
  const onChangeSymbolicDate = useCallback(
    (value) => dispatch(setSymbolicDate(value)),
    [dispatch]
  );
  const onChange = useCallback(
    (value) => dispatch(setAsOfDate(value)),
    [dispatch]
  );
  return (
    <DatePicker
      onChange={onChange}
      selected={asOfDate}
      onChangeSymbolicDate={onChangeSymbolicDate}
      symbolicDate={symbolicDate}
      quickSelectButtons={quickSelectButtons}
      variation={1}
      label="As of Date:"
      enableQuickSelect
      showMonthDropdown
      showYearDropdown
    />
  );
};

export default AsOfDatePicker;
